<template>
    <div>
        <h5>All Users</h5>

        <!-- Search User Criteria -->
        <search-user-criteria @set-criteria="setCriteria" />

        <!-- User table -->
        <user-table :criteriaFilters="criteriaFilters" :reloadTable="reloadTable" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import SearchUserCriteria from '@/components/user/SearchUserCriteria.vue';
import UserTable from '@/components/user/UserTable.vue';

const reloadTable = ref(false);
const criteriaFilters = ref([]);

const setCriteria = (criteria) => {
    criteriaFilters.value = criteria;
    reloadTable.value = !reloadTable.value;
};
</script>
